import { useState } from "react";
import { searchUsers, addFriend } from "../services/friendService";

export default function FriendSearch({ onFriendAdded }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const handleChange = async (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value.trim().length < 2) {
      setResults([]);
      return;
    }
    setSearching(true);
    try {
      const data = await searchUsers(value.trim());
      setResults(data);
    } finally {
      setSearching(false);
    }
  };

  const handleAdd = async (id) => {
    await addFriend(id);
    setResults((prev) =>
      prev.map((u) => (u.id === id ? { ...u, deja_ami: 1 } : u))
    );
    onFriendAdded();
  };

  return (
    <div className="card friend-search">
      <h3>Ajouter un ami</h3>
      <input
        type="text"
        placeholder="Rechercher un pseudo..."
        value={query}
        onChange={handleChange}
      />
      {searching && <p className="muted">Recherche...</p>}
      <ul className="search-results">
        {results.map((u) => (
          <li key={u.id}>
            <span>{u.pseudo}</span>
            {Number(u.deja_ami) === 1 ? (
              <span className="tag">Déjà ami</span>
            ) : (
              <button className="btn-secondary" onClick={() => handleAdd(u.id)}>
                Ajouter
              </button>
            )}
          </li>
        ))}
        {query.trim().length >= 2 && !searching && results.length === 0 && (
          <li className="muted">Aucun résultat</li>
        )}
      </ul>
    </div>
  );
}
